import { useState, useEffect } from "react";

// Operator-settable SAFE BATCH SIZE: the max number of labels sent in one
// uninterrupted sub-run before the sender pauses and starts a fresh sub-run.
// A long single run (e.g. 200 in one go) can silently stall the printer/Browser
// Print; splitting into paced sub-runs avoids that. Default 80 = the size the
// user has PROVEN prints cleanly; raise it in the confirm dialog once the
// binary-search on the real printer nails the true reliable max — no rebuild.
const KEY = "fas_print_chunk_size";
const DEFAULT = 80;
const MIN = 5;
const MAX = 600;
const listeners = new Set();

export function getPrintChunkSize() {
  try {
    const n = parseInt(localStorage.getItem(KEY) || "", 10);
    if (Number.isFinite(n) && n >= MIN) return Math.min(MAX, n);
  } catch { /* ignore */ }
  return DEFAULT;
}

export function setPrintChunkSize(n) {
  const v = Math.max(MIN, Math.min(MAX, parseInt(n, 10) || DEFAULT));
  try { localStorage.setItem(KEY, String(v)); } catch { /* ignore */ }
  listeners.forEach((fn) => fn(v));
  return v;
}

export function usePrintChunkSize() {
  const [n, setN] = useState(getPrintChunkSize());
  useEffect(() => {
    listeners.add(setN);
    const onStorage = (e) => { if (e.key === KEY) setN(getPrintChunkSize()); };
    window.addEventListener("storage", onStorage);
    return () => { listeners.delete(setN); window.removeEventListener("storage", onStorage); };
  }, []);
  return [n, setPrintChunkSize];
}

export const PRINT_CHUNK_DEFAULT = DEFAULT;
